var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemStrikethrough = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M16.684 13c.2.457.316 1.001.316 1.652 0 2.48-1.597 4.349-4.846 4.349-2.34 0-4.01-.874-5.154-2.154l1.416-2.256c.853.996 2.177 1.85 3.847 1.85 1.434 0 2.105-.712 2.105-1.504 0-1.222-1.873-1.368-3.678-1.937zm2.816-1.5a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zM11.99 5c1.925 0 3.522.65 4.72 1.89l-1.434 2.154a4.9 4.9 0 0 0-3.521-1.483c-1.089 0-1.706.528-1.706 1.34 0 1.252 2.392 1.273 4.37 2.098L7.822 11c-.266-.497-.423-1.11-.423-1.875 0-2.255 1.743-4.124 4.592-4.124"
})));
export default SvgGemStrikethrough;